import { GenericService } from './generic.service';
import { DocumentTemplate } from '@/models';

export class DocumentTemplateService extends GenericService<DocumentTemplate> {

  constructor() {
    super('v1/document-templates');
  }
}
